export const automationSettingsInputState = (campaign) => {
    const state = { stepCompleted: false, stepEdited: false };

    if (campaign?.copyTypes?.length > 0) {
        state.stepEdited = true;
    }

    // ToDo: add any further checks required

    return state;
};

const dayPartEnglish = (daypartqtrs) => {
    // const usedQtrs = [];
    const contiguous = {};
    // let ky = '00:00';
    let lasti = -1;
    const daypartsels = {};
    daypartqtrs.map((a) => {
        daypartsels[a] = a;
    });

    let laststart = '00:00';
    for (let i = 0; i < 96; i++) {
        const m = i % 4 < 1 ? '00' : (i % 4) * 15;

        const h = Math.floor(i / 4) + ':';

        if (daypartsels[h + m]) {
            let m1 = ((i + 1) % 4) * 15;
            if (!m1) m1 = '00';
            const h1 = Math.floor((i + 1) / 4) + ':';
            if (lasti === i - 1) {
                contiguous[laststart] = h1 + m1;
                lasti = i;
            } else {
                lasti = i;
                laststart = h + m;
                contiguous[laststart] = h1 + m1;
            }
        }
    }
    let result = '';
    const termCount = Object.keys(contiguous).length;
    let cnt = 1;
    for (const prop in contiguous) {
        result += prop + ' to ' + contiguous[prop] + (cnt === termCount ? '' : cnt === termCount - 1 ? ' and ' : ',');
        cnt++;
    }
    return result;
};

export const ListToEnglish = (objs, sels, isDaypart) => {
    if (sels.length) {
        let sList = '';
        let connector = sels.length > 1 ? ', ' : '';
        sels.map((a, b) => {
            const st = objs.find((s) => s.id.toString() === a.toString());
            if (st) {
                sList += st ? st.name : '';
                if (b < sels.length - 1) sList += connector;
                if (b === sels.length - 3) {
                    connector = ' and ';
                }
            }
            return true;
        });
        if (isDaypart) {
            return dayPartEnglish(sels);
        }
        return sList;
    }
};

export const nameOf = (staticData, ct) => {
    const sf = staticData.scriptFactors.find((s) => s.id === ct.scriptFactorId);
    const st = staticData.spotTypes.find((s) => s.id === ct.spotTypeId);

    return sf?.description + ' ' + st?.name;
};

export const nameFromExclusion = (campaign, staticData, currentDaysOfWeek, currentDayparts, currentWeeks, excl) => {
    const ct = campaign.copyTypes.find((s) => s.id === excl.copyTypes[0]);
    let nm = ct ? nameOf(staticData, ct) : window.translate('All Copy ');

    if (excl.stations?.length === 1 && excl.stations[0] === window.emptyGuid) {
        nm += window.translate(' on All Stations ');
    } else {
        const stationList = ListToEnglish(campaign.campaignStations ?? campaign.burstStations, excl.stations);
        if (stationList) nm += window.translate(' from ') + stationList;
    }

    const dayList = ListToEnglish(currentDaysOfWeek, excl.daysOfWeek);
    if (dayList) nm += window.translate(' on ') + dayList;

    if (excl.dayParts?.length === 1 && excl.dayParts[0] === window.emptyGuid) {
        nm += window.translate(' on All Dayparts ');
    } else {
        const dpList = ListToEnglish(currentDayparts, excl.dayParts, true);
        if (dpList) nm += window.translate(' between ') + dpList;
    }

    if (excl.weeks?.length === 1 && excl.weeks[0] < 0) {
        const week = currentWeeks.find((w) => w.id === excl.weeks[0]);
        if (week) nm += window.translate(' on ' + week.name);
    } else {
        const weeks = excl.weeks?.map((a, b) => {
            let returnString = '';
            if (b === excl.weeks.length - 1 && b !== 0) {
                returnString = ' & ' + a.toString();
            } else {
                if (b > 0) returnString = ' ';
                returnString += a.toString();
            }
            return returnString;
        });
        if (weeks.length > 0) nm += window.translate(excl.weeks.length > 1 ? ' on weeks ' : ' on week ') + weeks;
    }
    return nm;
};
